/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctString } from '../../../../Fct/generics';
import { getSupportedTokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
export var Name = createPlugin({
    protocol: 'ERC20',
    type: 'GETTER',
    method: 'name',
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({
                    destination: 'erc20',
                    options: getSupportedTokens({ chainId: chainId }),
                }),
                methodParams: {},
            },
            output: {
                name: new FctString({ innerIndex: 0 }),
            },
        });
    },
});
